<template>
    <sign-in-okta v-if="signInMethod.oktaEnabled" />
    <sign-in-form v-else-if="signInMethod.formEnabled" />
    <sign-in-code v-else-if="signInMethod.codeEnabled" />
</template>

<script setup lang="ts">

    definePageMeta({ layout: 'default-no-header' });

    const {signInMethod} = useAppConfig();
</script>